import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Switch, Typography } from 'antd';

const { Text } = Typography;

type EnabledSwitchProps = {
  value: boolean;
  onChange: (value: boolean) => void;
  label?: string;
  disabled?: boolean;
};

const EnabledSwitch = ({ value, onChange, label = 'Is enabled?', disabled }: EnabledSwitchProps) => {
  return (
    <div className="flex items-center justify-between rounded-lg border border-emerald-100 bg-white px-3 h-[40px]">
      <Text type="secondary" className="text-xs">
        {label}
      </Text>

      <Switch
        size="default"
        checked={value}
        onChange={onChange}
        disabled={disabled}
        checkedChildren={<CheckOutlined />}
        unCheckedChildren={<CloseOutlined />}
      />
    </div>
  );
};

export default EnabledSwitch;
